/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_DescriptionInputs */

const en_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Job Description`)
};

const de_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellenbeschreibung`)
};

const fr_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Description du poste`)
};

const es_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descripción del puesto`)
};

const it_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descrizione del lavoro`)
};

const nl_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vacaturetekst`)
};

const pl_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opis stanowiska`)
};

const fi_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Työpaikkakuvaus`)
};

const da_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbeskrivelse`)
};

const sv_jobs_description = /** @type {(inputs: Jobs_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobbbeskrivning`)
};

/**
* | output |
* | --- |
* | "Job Description" |
*
* @param {Jobs_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_description = /** @type {((inputs?: Jobs_DescriptionInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_DescriptionInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_description(inputs)
	if (locale === "fr") return fr_jobs_description(inputs)
	if (locale === "es") return es_jobs_description(inputs)
	if (locale === "it") return it_jobs_description(inputs)
	if (locale === "nl") return nl_jobs_description(inputs)
	if (locale === "pl") return pl_jobs_description(inputs)
	if (locale === "fi") return fi_jobs_description(inputs)
	if (locale === "da") return da_jobs_description(inputs)
	if (locale === "sv") return sv_jobs_description(inputs)
	return en_jobs_description(inputs)
});